import React from 'react';
import styled, {css} from 'styled-components';

import {Popup} from 'semantic-ui-react';

const InfoStyle = styled(Popup)`
  font-size: 12px !important;
  font-weight: 400;
  line-height: 18px !important;
  letter-spacing: 0;
  text-align: left;
  padding-top: 13px !important;
  padding-bottom: 13px !important;

  a {
    color: #89e2ff;
  }

  .popup {
    &__label {
      &_line {
        background-color: rgba(141, 150, 160, 1);
        width: 100%;
        height: 1px;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
`;

const Info = ({
                  text = '',
                  label = '',
                  name = '',
                  position = 'center',
                  className,
                  offset = [],
                  trigger,
                  absolutePosition
              }) =>
    (
        <InfoStyle
            content={
                <div>
                    <div className='popup__label'><b>{name}{label && name ? ':' : ''}</b> {label}</div>
                    {(text && (label || name)) && <div className='popup__label_line'/>}
                    <div style={{whiteSpace: 'pre-line'}}>{text}</div>
                </div>
            }
            position={absolutePosition || (String(position || '').includes(' ') ? position : `bottom ${position}`)}
            size='mini'
            inverted
            hoverable
            offset={offset}
            trigger={
                trigger ? trigger : <svg className={`popup__svg ${className}`} width="15" height="14" viewBox="0 0 15 14"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7.59297 0C3.72748 0 0.593262 3.13422 0.593262 6.9997C0.593262 10.8652 3.72748 14 7.59297 14C11.4584 14 14.5933 10.8652 14.5933 6.9997C14.5933 3.13422 11.4584 0 7.59297 0ZM9.05015 10.8486C8.68985 10.9908 8.40304 11.0987 8.18793 11.1733C7.97341 11.248 7.72393 11.2853 7.44008 11.2853C7.00393 11.2853 6.66437 11.1787 6.4226 10.9659C6.18082 10.7532 6.06052 10.4836 6.06052 10.1559C6.06052 10.0284 6.06941 9.89807 6.08719 9.76533C6.10556 9.63259 6.1346 9.48326 6.1743 9.31556L6.62526 7.72267C6.66497 7.56978 6.69934 7.42459 6.7266 7.28948C6.75385 7.15319 6.76689 7.02815 6.76689 6.91437C6.76689 6.7117 6.72482 6.56948 6.64126 6.48948C6.55652 6.40948 6.39711 6.37037 6.15948 6.37037C6.04334 6.37037 5.92363 6.38756 5.80097 6.4237C5.67948 6.46104 5.574 6.49481 5.48748 6.528L5.6066 6.03733C5.90171 5.91704 6.18437 5.81393 6.454 5.72859C6.72363 5.64207 6.97845 5.59941 7.21845 5.59941C7.65163 5.59941 7.98585 5.70489 8.22111 5.91348C8.45519 6.12267 8.57311 6.39467 8.57311 6.72889C8.57311 6.79822 8.56482 6.9203 8.54882 7.09452C8.53282 7.26933 8.50259 7.42874 8.45874 7.57511L8.01015 9.16326C7.97341 9.29067 7.94082 9.43644 7.91119 9.59941C7.88215 9.76237 7.86793 9.88682 7.86793 9.97037C7.86793 10.1813 7.91474 10.3253 8.00956 10.4018C8.10319 10.4782 8.26734 10.5167 8.49963 10.5167C8.60926 10.5167 8.73193 10.4972 8.8706 10.4593C9.00808 10.4213 9.10763 10.3876 9.17045 10.3585L9.05015 10.8486ZM8.97074 4.40237C8.76156 4.59674 8.50971 4.69393 8.21519 4.69393C7.92126 4.69393 7.66763 4.59674 7.45667 4.40237C7.24689 4.208 7.14082 3.97156 7.14082 3.69541C7.14082 3.41985 7.24748 3.18281 7.45667 2.98667C7.66763 2.78993 7.92126 2.69215 8.21519 2.69215C8.50971 2.69215 8.76215 2.78993 8.97074 2.98667C9.17993 3.18281 9.28482 3.41985 9.28482 3.69541C9.28482 3.97215 9.17993 4.208 8.97074 4.40237Z"
                        fill="#459EFF"/>
                </svg>
            }
        />
    );

export default Info;



// WEBPACK FOOTER //
// ./App/components/Info.jsx